<script>
export let split;
export let pos = 0.5;
export let buffer = 0.08; // fraction of the height that we're not allowed to drag beyond

let container; // Overall container has width w, height h
let w, h;
let dragging = false;
let isVertical = (split === 'vertical');

$: size = isVertical ? h : w;
$: pos = (pos < buffer ? buffer: (pos > 1-buffer ? 1-buffer : pos));


// The main container has <div use:drag>, so Svelte calls drag(<div>)
// (Should do the same thing with a use:touchDrag ...)

function drag(node) {
    function setPos(event) {
        const { top, left } = container.getBoundingClientRect();
        const px = (split === 'vertical') ? (event.clientY - top) : (event.clientX - left);
        pos = px / size;
    }
    const mousedown = event => {
        if (event.which !== 1) return;
        event.preventDefault();
        dragging = true;
        const onmouseup = () => {
            dragging = false;
            window.removeEventListener('mousemove', setPos, false);
            window.removeEventListener('mouseup', onmouseup, false);
        };
        window.addEventListener('mousemove', setPos, false);
        window.addEventListener('mouseup', onmouseup, false);
    }
    node.addEventListener('mousedown', mousedown, false);
    return {
        destroy() {
            node.removeEventListener('mousedown', mousedown, false);
        }
    };
}

</script>


<div class="container" bind:this={container} bind:clientWidth={w} bind:clientHeight={h}>
	<div class="pane" style="{isVertical ? 'height' : 'width'}: {100*pos}%;">
		<slot name="a"></slot>
	</div>

	<div class="pane" style="{isVertical ? 'height' : 'width'}: {100*(1-pos)}%;">
		<slot name="b"></slot>
	</div>

    <div class="{split} divider" class:dragging={dragging} style="{isVertical ? 'top' : 'left'}: calc({100*pos}% - var(--divider-size))" use:drag></div>
</div>

{#if dragging}
	<div class="mousecatcher"></div>
{/if}


<style>
:root {
    --divider-size: 4pt;
}

.container {
    position: relative;
    width: 100%;
    height: 100%;
}

.pane {
    position: relative;
    float: left;
    width: 100%;
    height: 100%;
    overflow: auto;
}

.mousecatcher {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(117, 29, 29, 0.01);
}

.divider {
    position: absolute;
    z-index: 10;
    display: none;
}
.divider:hover {
    background-color: #40b3ff0c;
}
.divider.dragging {
    background-color: #40b3ff25;
}

.horizontal {
    padding: 0 var(--divider-size);
    width: 0;
    height: 100%;
    cursor: ew-resize;
}

.vertical {
    padding: var(--divider-size) 0;
    width: 100%;
    height: 0;
    cursor: ns-resize;
}

.left, .right, .divider {
    display: block;
}

.left, .right {
    height: 100%;
    float: left;
}

.top, .bottom {
    position: absolute;
    width: 100%;
}

.top { top: 0; }
.bottom { bottom: 0; }
</style>

<!--

function setTouchPos(event) {
    const { top, left } = container.getBoundingClientRect();
    const px = (direction === 'vertical') ? (event.touches[0].clientY - top) : (event.touches[0].clientX - left);
    pos = 100 * px / size;
    dispatch('change');
}

function touchDrag(node, callback) {
    const touchdown = event => {
        if (event.targetTouches.length > 1) return;

        event.preventDefault();

        dragging = true;

        const ontouchend = () => {
            dragging = false;

            window.removeEventListener('touchmove', callback, false);
            window.removeEventListener('touchend', ontouchend, false);
        };

        window.addEventListener('touchmove', callback, false);
        window.addEventListener('touchend', ontouchend, false);
    }

    node.addEventListener('touchstart', touchdown, false);

    return {
        destroy() {
            node.removeEventListener('touchstart', touchdown, false);
        }
    };
}

-->